import { css } from 'styled-components';

export const tableCarouselItemMixin = ({
  $rowsCount
}: {
  $rowsCount: number;
}) => css`
  & > div {
    display: grid;
    grid-template-rows: subgrid;
    grid-template-columns: subgrid;
    grid-row: 1 / ${$rowsCount + 1};
  }
`;
